import { render, staticRenderFns } from "./RfxManageQuicklinks.vue?vue&type=template&id=bed72b46"
import script from "./RfxManageQuicklinks.vue?vue&type=script&lang=js"
export * from "./RfxManageQuicklinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports